import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useLoginMutation } from 'bxcommon/store/endpoints/user.endpoints';
import BaseLogin from 'bxcommon/components/BaseLogin/BaseLogin';
import errorService, { LOGIN_ERRORS } from 'bxcommon/helpers/errors.helper';

export const AdminLogin = () => {
  const { t: common } = useTranslation('common');

  const loginAsAdmin = true;

  const [login] = useLoginMutation();

  const warning = useCallback((error) => {
    errorService.handleErrorToast(error, LOGIN_ERRORS);
  }, []);

  return (
    <BaseLogin
      isAdvisor
      isAdmin
      login={(data) => login({ data, loginAsAdmin }).unwrap()}
      warning={warning}
      heading={common('login.admin.heading')}
    />
  );
};

export default AdminLogin;
